export const EDITING_RULES = {
  OVERRIDE: 'OVERRIDE',
  SYNC: 'SYNC',
  DETAIL: 'DETAIL',
};

export const ROW_TYPES = {
  SUMMARY: 'SUMMARY',
};

export const gridOptions = {
  sideBar: {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      },
    ],
    defaultToolPanel: '',
  },
};

export const BASE_PREFIX = 'BASE_';
export const COMPARE_PREFIX = 'COMPARE_';
export const VARIANCE_PREFIX = 'VARIANCE_';

export const TOUCHED_FLAG_SUFFIX = '_TOUCHED_FLAG';

export const LABEL_COLUMN_ID = 'label';
